module.exports = __webpack_public_path__ + "static/media/ps3.ea26c0ee.webp";